import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SCUIContent } from '../../atomic/organisms';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import { MannequinProvider } from './context/MannequinContext';
import { HangerPhotographyFlow } from './components/AIGeneration/HangerPhotographyFlow';
import { PageUrl } from '../../types/enums/pageUrl-enums';

interface LocationState {
    typeName?: string;
}

const AIGenerationWrapper = () => {
    const location = useLocation<LocationState>();
    const { t } = useTranslation();

    const typeName = location.state?.typeName;
    const breadcrumbTitle = typeName
        ? `${t('mannequin.aiGeneration.hangerFlow.uploadGenerate.title')} - ${typeName}`
        : t('mannequin.aiGeneration.hangerFlow.uploadGenerate.title');

    return (
        <SCUIContent className="ai-generation-full-screen">
            <SCUIBreadCrumb
                title={t('mannequin.aiGeneration.typeSelector.title')}
                componentLink={PageUrl.studioRoutes.aiGeneration.url}
                components={[
                    {
                        title: breadcrumbTitle,
                        link: undefined,
                    },
                ]}
            />
            <HangerPhotographyFlow />
        </SCUIContent>
    );
};

export const AIGenerationPage = () => {
    return (
        <MannequinProvider>
            <AIGenerationWrapper />
        </MannequinProvider>
    );
};
